<template lang="pug">
  section#about
    .section-title about.
    .about-info
      .info-img(:style="{ backgroundImage: 'url(' + about.aboutImg + ')' }")
      .info-text
        .info-title
          p I’m Chang Wen Han.
        .info-en
          p A programmer. An artist. A game developer. A designer. A musician.
          .br
          p If you have any website production, interactive devices or digital art creation related project in demand, feel free to contact me.
        .info-zh
          p 我是張文瀚。一位工程師、藝術創作者、遊戲開發者、設計師、樂手，畢業於政治大學數位內容所。
          .br
          p 如有網站製作、互動裝置、數位藝術創作之需求歡迎洽談。
    .about-list
      .list-title
        p Experience.
      .list-table
        .row(v-for="data in about.experiences")
          .left
            p {{data.year}}
          .right
            p(v-for="content in data.content")
              | {{content}}
    .about-list
      .list-title
        p Exhibitions.
      .list-table
        .row(v-for="data in about.exhibitions")
          .left
            p {{data.year}}
          .right
            p(v-for="content in data.content")
              | {{content}}
    .about-list
      .list-title
        p Skills.
      .list-table
        .row(v-for="data in about.skills")
          .right
            p(v-for="content in data.content")
              | {{content}}
    .about-list
      .list-title
        p Contact.
      .list-table
        .row
          .right
            p changwenhan.studio@gmail.com
            .br
            a(href="https://www.linkedin.com/in/wen-han-chang/" target="_blank")
              | linkedin
            a(href="https://www.facebook.com/bbbb0y" target="_blank")
              | facebook
            a(href="https://www.instagram.com/bbbb00y/" target="_blank")
              | instagram

</template>

<script>


export default {
  name: 'About',
  // components: { WorkBox },
  props: ['screenSize'],
  data () {
    return {
      about: {
        aboutImg: require("@/assets/images/about-img.jpg"),
        experiences: [
          {
            year: "2022 -",
            content: [
              "LeetCode - Web Frontend Engineer (Remote)",
              "LeetCode - 前端工程師（遠端）"
            ]
          },
          {
            year: "2019 -",
            content: [
              "Freelancer, Artist",
              "接案自由工作者、藝術家"
            ]
          },
          {
            year: "2020 - 2022",
            content: [
              "Team9 Game Studio - Chief Technical Officer, Game Engineer",
              "烴奈股份有限公司 - 技術長、遊戲工程師"
            ]
          },
          {
            year: "2020 - 2022",
            content: [
              "BlackHole Creative - Web Frontend Engineer (Part-time)",
              "黑洞創造有限公司 - 前端工程師（兼職）"
            ]
          },
          {
            year: "2020 - 2022",
            content: [
              "Academy of Arts, National Tsing Hua University - Adjunct Lecturer",
              "清華大學藝術學院 - 兼任教師"
            ]
          },
          {
            year: "2017 - 2019",
            content: [
              "Catchad - Digital Interactive Designer",
              "貓取廣告 - 數位互動設計師"
            ]
          },
          {
            year: "2017 - 2019",
            content: [
              "Leon Zheng - Live Concert Bassist + Backing Vocalist",
              "鄭興Leon Zheng - 現場演出貝斯手+合音"
            ]
          },
          {
            year: "2017 - 2019",
            content: [
              "NCCU Digital Content & Technologies - Master's degree",
              "政治大學數位內容碩士學位學程"
            ]
          },
          {
            year: "2013 - 2017",
            content: [
              "NCCU Management Information Systems - Bachelor's degree",
              "政治大學資訊管理學系"
            ]
          },
        ],
        exhibitions: [
          {
            year: "2021",
            content: [
              "“DigiWave”  @ The Pier-2 Art Center, Kaohsiung",
              "《DigiWave》高雄駁二藝術特區"
            ]
          },
          {
            year: "",
            content: [
              "“Taipei Game Show”  @ Nangang Exhibition Hall, Taipei",
              "《台北國際電玩展》台北南港展覽館"
            ]
          },
          {
            year: "2019",
            content: [
              "“Athens Digital Arts Festival”  @ Athens, Greece",
              "《雅典數位藝術節》希臘雅典"
            ]
          },
          {
            year: "",
            content: [
              "“HYPER SPACE”  @ NCCU Art Center, Taipei",
              "《HYPER SPACE》政治大學藝文中心"
            ]
          },
          {
            year: "",
            content: [
              "“Synthetic Media Arts Festival”  @ EXPO Park, Taipei",
              "《合成媒體藝術節》台北花博流行館"
            ]
          },
          {
            year: "2018",
            content: [
              "“Samsung Studio”  @ ATT 4 FUN, Taipei",
              "《三星 Samsung Studio》台北 ATT 4 FUN"
            ]
          },
          {
            year: "",
            content: [
              "“Taipei Nuit Blanche”  @ Zhongshan North Road, Taipei",
              "《台北白晝之夜》台北中山北路"
            ]
          },
          {
            year: "2016",
            content: [
              "“NCCU Arts Festival”  @ NCCU Art Center, Taipei",
              "《政大藝術季》政治大學藝文中心"
            ]
          },

        ],
        skills: [
          {
            content: [
              "Web Development: ",
              "Html5 / React.js / Vue.js / Three.js / Babylon.js / Aframe.js / Pixi.js / P5.js / GLSL shader / Node.js"
            ]
          },
          {
            content: [
              "Interactive Project Development: ",
              "Unity Engine / Godot Engine / Arduino / Max/MSP / Processing / Blender"
            ]
          },
          {
            content: [
              "Design, Editing:",
              "Figma / Adobe Illustrator / Adobe Photoshop / Adobe Premiere Pro"
            ]
          },
          {
            content: [
              "Music:",
              "Acoustic Guitar / Electric Guitar / Electric Bass Guitar / Logic Pro / Ableton Live"
            ]
          },
        ]
      }
    }
  },
  methods: {
    more: function() {
      let data = 1;
      this.datas.push(data);
    }
  }
}
</script>

<style lang="sass" scoped>
  #about
    display: flex
    flex-direction: column
    max-width: 1000px
    padding-top: 180px
    @media screen and (max-width: 600px)
      padding-top: 100px
    >*
      flex: 0 0 auto

  .br
    margin: 15px 0

  a
    color: #fff
    text-decoration: underline

  .about-info
    width: 100%
    display: flex
    margin-top: 100px
    margin-bottom: 80px
    .info-img
      flex: 1
      background-size: cover
      background-position: 50% 50%
      filter: grayscale(100%)
      margin-right: 20px
      border: 1px solid #fff
      &:before
        content: ""
        display: block
        padding-top: 70.25%
    .info-text
      display: flex
      flex: 1
      flex-direction: column
      margin-left: 20px
      line-height: 1.5
      .info-title
        font-size: 20px
        margin-bottom: 30px
      .info-en
        font-size: 14px
        margin-bottom: 30px
      .info-zh
        font-size: 16px
    @media screen and (max-width: 600px)
      flex-direction: column
      .info-img
        margin-right: 0
        margin-bottom: 20px
      .info-text
        margin-left: 0
  .about-list
    width: 100%
    display: flex
    flex-direction: column
    line-height: 1.5
    margin-bottom: 50px
    .list-title
      font-size: 30px
      margin-bottom: 50px
    .list-table
      width: 100%
      display: flex
      flex-direction: column
      font-size: 16px
      .row
        display: flex
        margin-bottom: 30px
        .left
          width: 17%
        .right
          display: flex
          flex-direction: column
        @media screen and (max-width: 600px)
          flex-direction: column
          .left
            width: auto
            margin-bottom: 10px
</style>



// WEBPACK FOOTER //
// src/components/About.vue